// requiring html templates so that hot reloading works
import {isEmpty} from "lodash-es";
import {BookingOptionTypes, PaymentTypes} from "app/app.types";
import {PricingTypes} from "shared-types/index";
import BookingOptionsManagerService from "app/services/bookingOptionsManager/bookingOptionsManager.service";
import AdminService from "external-services/diary-admin-service/admin.service";
import DateUtilsService from 'external-services/date-utils-service';

const template = require('./paymentConfig.html');

const NS = 'PaymentConfig.directive';

export default function PaymentConfig() {
  return {
    bindToController: true,
    template,
    controllerAs: 'vm',
    restrict: 'E',
    scope: {
      paymentForm: '=?',
      displayErrors: '<',
      // hasMenuOptionsError: '=',
      details: '=',
      types: '=',
      privateFunction: '=',
      enableDatesRange: '=',
      datesRangeChange: '&'
    },
    controller
  };
}

function controller($scope, appConstants, unregister, $mdDialog) {

  "ngInject";

  const listeners = [];

  const vm = this;

  vm.maxDate = '9999-12-31';

  vm.venue = AdminService.getVenue();
  vm.paymentTypes = appConstants.Payment.PaymentTypes;
  vm.pricingTypes = PricingTypes;
  vm.bookingOptionTypes = BookingOptionTypes;
  vm.paymentType = vm.paymentTypes.NoPayment;
  vm.overrideMinValue = 0;
  vm.datesRange = {};
  vm.menuOptions = [];
  vm.menuOptionsUpsell = [];
  vm.menuOptionsRequired = false;
  vm.paymentTypeChange = paymentTypeChange;
  vm.addUpsellOptions = addUpsellOptions;

  vm.numbersWithTwoDecimals = "^\\d*\\.?\\d{0,1}$";

  listeners.push($scope.$watch('vm.paymentType', paymentTypeChangeForEvent));
  listeners.push($scope.$watch('vm.types', typesChange));
  listeners.push($scope.$watch('vm.details', detailsChange));
  listeners.push($scope.$watch('vm.details.peopleRequired', peopleRequiredChange));
  listeners.push($scope.$watch('vm.datesRange.from', datesChange));
  listeners.push($scope.$watch('vm.datesRange.to', datesChange));
  listeners.push($scope.$watch('vm.bookingOptionType', bookingOptionTypeChange));
  listeners.push($scope.$watch(() => vm.menuOptions.some(opt => opt.isIncompatiblePaymentType), setMenuOptionsError));
  listeners.push($scope.$watch(() => vm.menuOptions.some(opt => opt.isArchived), setMenuOptionsArchived));
  listeners.push($scope.$on('menuoptions-updated', menuOptionsChanged));
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));


  function typesChange() {
    if (vm.types.find(type => type.code === vm.details.paymentType) == null) {
      vm.paymentType = vm.details.paymentType = vm.types.length ?
        vm.types[0].code :
        vm.paymentTypes.NoPayment;
    }
  }

  function detailsChange() {
    vm.details.peopleRequired = vm.details.peopleRequired ?? 1;
    vm.details.pricingType = vm.details.pricingType ?? PricingTypes.PerPax;

    peopleRequiredChange();

    if (vm.details.singleMenuPerBooking != null) {
         vm.bookingOptionType = vm.details.pricingType == PricingTypes.PerBooking ?
          BookingOptionTypes.BookingOptionPerBooking :
          vm.details.singleMenuPerBooking ? BookingOptionTypes.WholeBookingOnOneOption : BookingOptionTypes.QuantitiesPerOption;
    }

    // Format dates from model format to ui widget
    if (vm.details.optionsFrom) {
      vm.datesRange.from = DateUtilsService.dateTimeStrToDate(vm.details.optionsFrom);
    }
    if (vm.details.optionsTo) {
      vm.datesRange.to = DateUtilsService.dateTimeStrToDate(vm.details.optionsTo);
    }

    // Load and map menuOptions
    BookingOptionsManagerService.getAll().then(options => {
      vm.menuOptions = (vm.details.menuOptions || []).reduce((acc, id) => {
        const matchedOpt = options.find(option => option._id === id);
        if (matchedOpt) {
          acc.push(matchedOpt);
        }
        return acc;
      }, []);

      vm.menuOptionsUpsell = (vm.details.menuOptionsUpsell || []).reduce((acc, id) => {
        const matchedOpt = options.find(option => option._id === id);
        if (matchedOpt) {
          acc.push(matchedOpt);
        }
        return acc;
      }, []);

      // Align vm.paymentType and vm.details.paymentType
      if (vm.details.price && vm.menuOptions.length) {
        console.warn(NS, 'dirty data detected. Cannot have a price and booking options. Removing price and showing booking options.', vm.details, vm.menuOptions);
        delete vm.details.price;
      }
      if (!vm.details.price && (vm.menuOptions.length || vm.menuOptionsUpsell.length)) {
        vm.paymentType = vm.paymentTypes.MenuOptions;
        vm.details.paymentType = findBookingOptionPaymentType(vm.menuOptions, vm.menuOptionsUpsell);
      } else {
        vm.details.paymentType = vm.details.paymentType || vm.paymentTypes.NoPayment;
        vm.paymentType = vm.details.paymentType;
      }
      updateUpsellText();
      vm.showUpsellButton = vm.paymentType !== vm.paymentTypes.MenuOptions;
    });

  }

  function paymentTypeChangeForEvent() {
    // NBI-7051
    // Hide UpsellButton when payment type is Function Payment
    if (vm.paymentType === PaymentTypes.FunctionPayment) {
      vm.showUpsellButton = false;
    }
  }

  function paymentTypeChange() {
    if (vm.paymentType !== vm.paymentTypes.MenuOptions) {
      vm.showUpsellButton = true;
      vm.details.paymentType = vm.paymentType;
      vm.details.pricingType = vm.details.pricingType ?? PricingTypes.PerPax;
      vm.details.menuOptions = [];
      vm.details.menuOptionsUpsell = [];
      vm.details.upsellHeading = '';
      vm.details.upsellDescription = '';
      vm.bookingOptionType = null;

      delete vm.details.maxPeoplePerBookingOverride;
      delete vm.details.discountPercentage;
      delete vm.details.optionsFrom;
      delete vm.details.optionsTo;
      delete vm.details.singleMenuPerBooking;
      if (vm.paymentType === vm.paymentTypes.NoPayment) {
        vm.details.pricingType = PricingTypes.PerPax;
        delete vm.details.price;
        delete vm.details.promotionCode;
        delete vm.details.discountAmount;
        delete vm.details.peopleRequired;
      }

      vm.datesRange = {};
      vm.menuOptions = [];
    } else {
      delete vm.details.price;
      delete vm.details.discountAmount;
      vm.details.peopleRequired = 1;
      vm.details.paymentType = findBookingOptionPaymentType(vm.menuOptions, vm.menuOptionsUpsell);
      vm.showUpsellButton = false;
      vm.bookingOptionType = vm.bookingOptionType || BookingOptionTypes.WholeBookingOnOneOption;

    }

    updateUpsellText();
  }

  function datesChange() {
    vm.details.optionsFrom = vm.datesRange.from ?
      DateUtilsService.dateToDateTimeStr(DateUtilsService.getClearDate(vm.datesRange.from, vm.venue.timeZoneId)) :
      null;

    vm.details.optionsTo = vm.datesRange.to ?
      DateUtilsService.dateToDateTimeStr(DateUtilsService.getClearDate(vm.datesRange.to, vm.venue.timeZoneId)) :
      null;

    $scope.$emit('dates-changed');
  }

  function bookingOptionTypeChange() {

    if(vm.paymentType != PaymentTypes.MenuOptions)
    {
      return;
    }

    if(vm.bookingOptionType == BookingOptionTypes.WholeBookingOnOneOption){
      vm.details.singleMenuPerBooking = true;
      vm.details.pricingType = PricingTypes.PerPax;

    }
    else if(vm.bookingOptionType ==  BookingOptionTypes.QuantitiesPerOption){
      vm.details.singleMenuPerBooking = false;
      vm.details.pricingType = PricingTypes.PerPax;

    }
    else if(vm.bookingOptionType == BookingOptionTypes.BookingOptionPerBooking){
      vm.details.singleMenuPerBooking = false;
      vm.details.pricingType = PricingTypes.PerBooking;
    }
  }


  function menuOptionsChanged() {

    if (!vm.menuOptions.length && !vm.menuOptionsUpsell.length) {
      vm.details.paymentType = vm.paymentTypes.NoPayment;
      vm.menuOptionsRequired = true;
      vm.paymentForm.$setValidity('bookingOptionValidator', false, window); // make validation as false if BO or UpsellOption not available
    } else {
      vm.menuOptionsRequired = false;
      vm.paymentForm.$setValidity('bookingOptionValidator', true, window); // make validation as true if BO or UpsellOption not available
    }

    if (vm.menuOptions.length) {
      vm.paymentForm.menuOptions.$touched = true;
      vm.details.menuOptions = vm.menuOptions.map(mo => mo._id);
      vm.details.paymentType = findBookingOptionPaymentType(vm.menuOptions, vm.menuOptionsUpsell);
    } else {
      vm.details.menuOptions = [];
      vm.details.peopleRequired = 1;
    }

    if (vm.menuOptionsUpsell.length) {
      vm.paymentForm.menuOptionsUpsell.$touched = true;
      vm.details.menuOptionsUpsell = vm.menuOptionsUpsell.map(mo => mo._id);
      vm.details.paymentType = findBookingOptionPaymentType(vm.menuOptions, vm.menuOptionsUpsell);
    } else {
      vm.details.menuOptionsUpsell = [];
    }
    vm.menuOptions = [...vm.menuOptions];

  }

  function setMenuOptionsError(val) {
    vm.hasMenuOptionsError = val;
  }

  function setMenuOptionsArchived(val) {
    vm.hasArchivedMenuOptions = val;
  }

  function peopleRequiredChange() {
    vm.overrideMinValue = Math.max((vm.venue.maxPeoplePerOnlineBooking || 0), vm.details.peopleRequired);
  }

  function findBookingOptionPaymentType(menuOptions, upsellOptions) {
    // Calculating payment type by including both menuOptions and upsellOptions - Fixing issue where if you add No Payment to Upsell you can add any payment type
    const allMenuOptions = !isEmpty(upsellOptions) ? [...menuOptions, ...upsellOptions] : menuOptions;
    const found = allMenuOptions.find(mo => mo.paymentType !== vm.paymentTypes.NoPayment) || allMenuOptions[0];
    return found ? found.paymentType : vm.paymentTypes.NoPayment;
  }

  function addUpsellOptions(evt) {
    const detailsParent = vm.details;
    $mdDialog.show({
      controller: 'NewUpsellCtrl',
      controllerAs: 'vm',
      clickOutsideToClose: true,
      locals: {
        details: detailsParent
      },
      templateUrl: 'app/settings/upsell/newUpsell.html',
      targetEvent: evt
    }).then(
      function (successData) {
        updateUpsellText()
      });
  }

  function updateUpsellText() {
    vm.upsellText = vm.details && vm.details.menuOptionsUpsell && vm.details.menuOptionsUpsell.length > 0 ? 'Edit Upsell items' : 'Add Upsell items';
  }

}
